import { combineReducers } from "@reduxjs/toolkit";
import registersSidebarReducer from "./registersSidebar";

const sidebarsReducers = combineReducers({
  registersSidebar: registersSidebarReducer,
});

export default sidebarsReducers;
